import { render, staticRenderFns } from "./ProductBanner.vue?vue&type=template&id=29cdba17"
import script from "./ProductBanner.vue?vue&type=script&lang=js"
export * from "./ProductBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports